import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  @Input() type: 'primary' | 'secondary' | 'neutral' = 'primary';
  @Input() transparent = false;
  @Input() uppercase = true;

  getStyles() {
    return {
      'transparent': this.transparent,
      'uppercase': this.uppercase,
      [this.type]: true
    };
  }
}
